import state from './Refund/states'
import mutations from './Refund/mutations'
import actions from './Refund/actions'
import getters from './Refund/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
